var React = require('react');

function ClockInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 0C4.93604 0 0 4.93604 0 11C0 17.064 4.93604 22 11 22C17.064 22 22 17.064 22 11C22 4.93604 17.064 0 11 0ZM11 21.0815C5.44092 21.0815 0.918457 16.5591 0.918457 11C0.918457 5.44092 5.44092 0.918457 11 0.918457C16.5591 0.918457 21.0815 5.44092 21.0815 11C21.0815 16.5591 16.5591 21.0815 11 21.0815Z","fill":"#9A9A9A","key":0}),React.createElement("path",{"d":"M11.4565 10.812V3.20654C11.4565 2.9541 11.2524 2.75 11 2.75C10.7476 2.75 10.5435 2.9541 10.5435 3.20654V11C10.5435 11.1235 10.5918 11.2363 10.6777 11.3223L14.8027 15.4473C14.894 15.5386 15.0122 15.5816 15.125 15.5816C15.2432 15.5816 15.3613 15.5386 15.4473 15.4473C15.6245 15.27 15.6245 14.98 15.4473 14.7974L11.4565 10.812Z","fill":"#9A9A9A","key":1})]);
}

ClockInline.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = ClockInline;

ClockInline.default = ClockInline;
